import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  className?: string;
  textClassName?: string;
}

const Logo: React.FC<LogoProps> = ({
  className = 'h-12 md:h-16 w-auto object-contain',
  textClassName = 'text-2xl font-bold text-white',
}) => {
  return (
    <Link to="/" className="flex-shrink-0 cursor-pointer py-2">
      <img className={className} src="/logo.jpg" alt="harmony engineering" />
      <div className={`hidden ${textClassName}`}>HARMONY ENGINEERING</div>
    </Link>
  );
};

export default Logo;
